module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_blog", [["div",{"id":"blog-container","class":"pad-lr pad-tb"}],["div",{"class":"clear"}],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/blog.tpl
// module id = 1204
// module chunks = 4